export enum RuleRoundingMode {
  UP = "UP",
  DOWN = "DOWN",
  MERCANTILE = "MERCANTILE",
}
